<template>
	<div class="update-container">
		<div class="update-content">
			<!-- Logo -->
			<div class="logo-wrapper">
				<img src="../assets/logo-sc-blanco.svg" alt="Logo" class="logo-img" />
			</div>

			<!-- Update Card -->
			<div class="update-card">
				<div class="update-icon">
					<v-icon size="32" color="#6200ea">mdi-download-circle-outline</v-icon>
				</div>
				<h1 class="update-title">{{ $t('update.txtTitle') }}</h1>
				<p class="update-message">{{ $t('update.txtUpdate') }}</p>

				<button
					class="reload-btn"
					:class="{ 'btn-disabled': !updateExists }"
					:disabled="!updateExists"
					@click.prevent="refreshApp"
				>
					<v-icon size="20" color="white" class="mr-2">mdi-reload</v-icon>
					{{ $t('update.btnReload') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
	name: "Update",
	data() {
		return {};
	},
    methods: {
        ...mapMutations({
            update: 'update',
            updateDowloadM: 'updateDowload'
        }),
        refreshApp() {
            this.update(false);
            this.updateDowloadM(false);
			if (!this.registration || !this.registration.waiting) return;
			this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
		},
    },
    computed: {
        ...mapState({
            updateExists: (state) => state.updateExists,
            registration: (state) => state.registration,
            updateDowload: (state) => state.updateDowload,
        }),
        updateDowload: {
            get () {
                return this.$store.state.updateDowload
            },
            set (val) {
                this.updateDowloadM(val);
            }
        }
    },
    mounted () {
        if (!this.updateDowload) {
            // Return
            this.$router.back();
        }
    }
};
</script>

<style scoped>
.update-container {
	min-height: 100vh;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.update-content {
	width: 100%;
	max-width: 340px;
}

.logo-wrapper {
	text-align: center;
	margin-bottom: 28px;
}

.logo-img {
	max-width: 180px;
	height: auto;
}

.update-card {
	background: #fff;
	border-radius: 16px;
	padding: 28px 24px;
	text-align: center;
}

.update-icon {
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background: #ede7f6;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto 18px;
}

.update-title {
	font-size: 20px;
	font-weight: 600;
	color: #1a1a1a;
	margin: 0 0 10px;
}

.update-message {
	font-size: 14px;
	color: #666;
	line-height: 1.5;
	margin: 0 0 24px;
}

.reload-btn {
	width: 100%;
	padding: 14px;
	border: none;
	border-radius: 10px;
	background: #6200ea;
	color: #fff;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
	display: flex;
	align-items: center;
	justify-content: center;
}

.reload-btn:active {
	transform: scale(0.98);
	background: #5000d0;
}

.btn-disabled {
	background: #ccc;
	cursor: not-allowed;
}

.btn-disabled:active {
	transform: none;
	background: #ccc;
}
</style>
